import Rails from "@rails/ujs";
import jQuery from "jquery";
import * as ActiveStorage from "@rails/activestorage";

window.jQuery = jQuery;
window.$ = jQuery;

import { replace as replaceIcons } from "feather-icons";
import * as bootstrap from "bootstrap";

import "./vendor/jquery.mask";

import "./core/bootstrap-material";
import "./core/input_masks";

Rails.start();
ActiveStorage.start();

document.addEventListener("DOMContentLoaded", () => {
  replaceIcons();
});
